'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002473 from "./presto.-Credentials-View$$anon$73.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dImpersonator$0024 from "./presto.types$-Impersonator$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$72() {
  this.aID = null;
  this.aIv = null;
  this.aIw = false;
  this.aIE = null;
  this.aIF = false;
  this.aII = null;
  this.aIB = null;
  this.aIC = false;
  this.aIx = null;
  this.aIy = false;
  this.aIz = null;
  this.aIA = false;
  this.aIG = false;
  this.aIH = false;
  this.aID = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aII = "Impersonator";
}
export { $c_Lpresto_CredentialsView$$anon$72 as $c_Lpresto_CredentialsView$$anon$72 };
$p = $c_Lpresto_CredentialsView$$anon$72.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$72;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$72() {
}
export { $h_Lpresto_CredentialsView$$anon$72 as $h_Lpresto_CredentialsView$$anon$72 };
$h_Lpresto_CredentialsView$$anon$72.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aID;
});
$p.M = (function() {
  if ((!this.aIw)) {
    this.aIv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aIw = true;
  }
  return this.aIv;
});
$p.O = (function() {
  if ((!this.aIF)) {
    this.aIE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aIF = true;
  }
  return this.aIE;
});
$p.E = (function() {
  return this.aII;
});
$p.t = (function() {
  if ((!this.aIC)) {
    this.aIB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIC = true;
  }
  return this.aIB;
});
$p.N = (function() {
  if ((!this.aIy)) {
    this.aIx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().jW(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIy = true;
  }
  return this.aIx;
});
$p.Q = (function() {
  if ((!this.aIA)) {
    this.aIz = new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002473.$c_Lpresto_CredentialsView$$anon$73();
    this.aIA = true;
  }
  return this.aIz;
});
$p.v = (function() {
  if ((!this.aIH)) {
    this.aIG = false;
    this.aIH = true;
  }
  return this.aIG;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee216) => ((p) => \u03b4scrutinee216.cFX(p)))($j_presto$002etypes$0024$002dImpersonator$0024.$m_Lpresto_types$Impersonator$())));
});
var $d_Lpresto_CredentialsView$$anon$72 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$72, "presto.CredentialsView$$anon$72", ({
  GB: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$72 as $d_Lpresto_CredentialsView$$anon$72 };
//# sourceMappingURL=presto.-Credentials-View$$anon$72.js.map
